import _pt from "prop-types";
import React from 'react';
import { t } from '../i18n';
export var SkipNav = function SkipNav(_ref) {
  var children = _ref.children,
      href = _ref.href,
      onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement("a", {
    className: "ds-c-skip-nav",
    href: href,
    onClick: onClick
  }, children !== null && children !== void 0 ? children : t('skipNav.default'));
};
SkipNav.propTypes = {
  /**
     * Skip nav label
     */
  children: _pt.node,

  /**
     * The anchor or target for the link (where the link will jump the user to)
     */
  href: _pt.string.isRequired,

  /**
     * An onClick handler used for manually setting focus on the content.
     * Sometimes it's necessary to manually set focus, like when an app uses hash
     * routing and element-id links will be mistaken for routes.
     */
  onClick: _pt.func
};
export default SkipNav;